export const INFO_NOTIFICATION = "info";
export const WARNING_NOTIFICATION = "warning";
export const ERROR_NOTIFICATION = "error";
export const SUCCESS_NOTIFICATION = "success";

export const notificationTypes = {
  COMPLAINT_APPROVAL_REQUEST: WARNING_NOTIFICATION,
  INVENTORY_REQUEST: SUCCESS_NOTIFICATION,
};

export const NOTIFICATION_CHANNEL = "notification";
export const USER_GUIDE_LINK =
  "https://drive.google.com/file/d/1SYc9FRRiI2OhhnYUAaZEgEYINrv1Hzj_/view?usp=drive_link";
export const PUSHER_CLIENT_LIB = "https://js.pusher.com/8.2.0/pusher.min.js";
